import type { GetAsyncFlowOneResponse } from '@Common/types/bo/async_flows';

/**
 * Lists each distinct transition once, in order of first appearance, suffixed with
 *  its count
 */
export function getAsyncFlowTransitionsSummary(
  asyncFlows: Pick<GetAsyncFlowOneResponse, 'transition'>[],
): string[] {
  const counts: { [k: string]: number } = {};

  for (const { transition } of asyncFlows) {
    counts[transition || 'N/A'] = (counts[transition || 'N/A'] || 0) + 1;
  }

  return Object.keys(counts).map((transition) =>
    counts[transition] > 1 ? `${transition} (${counts[transition]})` : transition,
  );
}
